t = require('views/internal/teacup-with-helpers')('popover_add_email')

module.exports = ->
  t.form ->

    if t.mustacheVar 'isManagedUser'
      t.p '.managed-user-banner', ->
        t.format 'this-trello-account-is-managed-by-enterprise-new-email-addresses-must-be-on-a-domain-that-belongs-to-enterprise', { enterpriseName: t.mustacheVar 'enterpriseName' }

    t.p '.error', { id: 'account-error' }

    t.div '.field', ->
      t.label { for: 'email' }, ->
        t.format 'new-email-address'
      t.input { id: 'email', type: 'email', name: 'email', value: '' }

    t.input '.primary.js-save-changes', { type: 'submit', value: t.l('send-confirmation-email') }

  t.hr()

  t.p '.quiet.u-bottom', ->
    t.format 'we-ll-send-an-email-to-the-address-you-enter-click-the-link-in-the-email-to-confirm-the-address'



// WEBPACK FOOTER //
// ./app/scripts/views/templates/popover_add_email.coffee